<script>
    export let totalCards = 0;
    export let onBack = () => {};
    export let onReset = () => {};
</script>

<div class="completion">
    <div class="completion-icon">🎉</div>
    <h2 class="text-success">Félicitations !</h2>
    <p class="text-base-content/70">
        Vous avez maîtrisé toutes les {totalCards} carte{totalCards > 1 ? "s" : ""} de ce deck !
    </p>

    <div class="achievement bg-success/10 border-success">
        <div class="achievement-icon">✓</div>
        <div class="achievement-content">
            <div class="achievement-title text-success">Deck maîtrisé</div>
            <div class="achievement-subtitle text-base-content/70">
                Toutes les cartes marquées comme faciles
            </div>
        </div>
    </div>

    <div class="completion-actions">
        <button class="primary-btn btn btn-primary" on:click={onReset}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <polyline points="23 4 23 10 17 10"></polyline>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
            Réinitialiser les révisions
        </button>
        <button class="secondary-btn btn btn-outline btn-primary" on:click={onBack}
            >Retour</button
        >
    </div>
</div>

<style>
    .completion {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2rem;
        padding: 2rem;
        min-height: 60vh;
        justify-content: center;
        text-align: center;
    }

    .completion-icon {
        font-size: 5rem;
        animation: celebrate 0.6s ease-out;
    }

    @keyframes celebrate {
        0% {
            transform: scale(0) rotate(0deg);
        }
        50% {
            transform: scale(1.2) rotate(10deg);
        }
        100% {
            transform: scale(1) rotate(0deg);
        }
    }

    .completion h2 {
        margin: 0;
        font-size: 2.5rem;
        font-weight: 700;
    }

    .completion > p {
        font-size: 1.2rem;
        margin: 0;
        max-width: 500px;
    }

    .achievement {
        display: flex;
        align-items: center;
        gap: 1.5rem;
        padding: 2rem;
        border-radius: 16px;
        border: 2px solid;
        max-width: 400px;
        width: 100%;
    }

    .achievement-icon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: oklch(var(--su));
        color: oklch(var(--suc));
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2rem;
        font-weight: 700;
        flex-shrink: 0;
    }

    .achievement-content {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        text-align: left;
    }

    .achievement-title {
        font-size: 1.25rem;
        font-weight: 700;
    }

    .achievement-subtitle {
        font-size: 0.95rem;
    }

    .completion-actions {
        display: flex;
        gap: 1rem;
        margin-top: 1rem;
    }

    .primary-btn,
    .secondary-btn {
        padding: 0.8rem 1.5rem;
        border-radius: 8px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
    }

    .primary-btn {
        border: none;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .secondary-btn {
        border: 2px solid;
    }

    @media (max-width: 640px) {
        .completion-icon {
            font-size: 4rem;
        }

        .completion h2 {
            font-size: 2rem;
        }

        .completion > p {
            font-size: 1rem;
        }

        .achievement {
            flex-direction: column;
            text-align: center;
        }

        .achievement-content {
            text-align: center;
        }

        .completion-actions {
            flex-direction: column;
            width: 100%;
        }

        .completion-actions button {
            width: 100%;
        }
    }
</style>
